// extracted by mini-css-extract-plugin
export default {"labels":"labelWithHR_labels__1AtwV","hr":"labelWithHR_hr__ar2QM"};